import { render, staticRenderFns } from "./MinimumBalanceFeeReductionRewardEditor.vue?vue&type=template&id=d6d63290&scoped=true"
import script from "./MinimumBalanceFeeReductionRewardEditor.vue?vue&type=script&lang=ts"
export * from "./MinimumBalanceFeeReductionRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d63290",
  null
  
)

export default component.exports